// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2oBdg","select":"Header_select__3lUF2","clinic":"Header_clinic__3iESc"};